export const FORM_NAME = 'loginForm'
export const PASSWORD_RESET_FORM = 'PASSWORD_RESET_FORM'

export const CHANGE_DATE_TIME_MODAL = 'CHANGE_DATE_TIME_MODAL'
export const SMS_CONFIRM = 'SMS_CONFIRM'
